import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const InputText = styled.div`
  width: 100%;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 0.8rem;
  color: ${Colors.text_Color_1};
  font-size: 0.65em;
  font-weight: 500;
  line-height: 10px;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 18px;
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;

  color: ${Colors.text_Color_1};
  font-size: 0.65em;
  font-weight: 300;

  background: ${Colors.Input_Color_1};

  resize: vertical;

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: border;

  &:read-only {
    opacity: 0.5;
  }

  /* ::-webkit-input-placeholder {
    color: ${Colors.text_Color_1};
  }
  :-ms-input-placeholder {
    color: ${Colors.text_Color_1};
  } */
  &::placeholder {
    color: ${Colors.text_Color_1};
  }
`;

export const PlaceholderWrapper = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  height: 36px;
  padding: 16px;
  border: 1px solid rgb(255 255 255 / 0);
  color: ${Colors.text_Color_1};
  font-size: 0.65em;
  font-weight: 300;
  opacity: 1;
  pointer-events: none;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: opacity;

  ${Textarea}:not(:placeholder-shown) ~ &,
  ${Textarea}:focus ~ & {
    opacity: 0;
  }
`;

export const Placeholder = styled.span`
  display: inline-block;
  height: 36px;
  color: #ffffff40;
`;

export const Error = styled.p`
  display: block;
  margin-top: 0.3rem;
  color: ${Colors.ftColor6};
  font-size: 0.7em;
  font-weight: 300;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: opacity;
`;
